// extracted by mini-css-extract-plugin
export default {"table":"table_table__TOtye","action":"table_action__lAfLW","cell":"table_cell__lfznf","option":"table_option__q+dmv","clear":"table_clear__EaaQi"};